export enum ValidationStringVariant {
	Default = 'default',
	Success = 'success',
	Error = 'error',
}

export interface ValidationStringProps {
	className?: string;
	variant?: ValidationStringVariant;
	children: string;
}
